export const name = 'tpaWorkerFeature' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
